


































































import { Component, Vue } from "vue-property-decorator"
import CandidateDashboardGetStarted from "./Dashboard/CandidateDashboardGetStarted.vue"
import CandidateDashboardConfirmScreen from "./Dashboard/CandidateDashboardConfirmScreen.vue"
import CandidateDashboardIncompletedList from "./Dashboard/CandidateDashboardIncompletedList.vue"
import { mapState } from "vuex"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"

@Component({
  components: {
    CandidateDashboardGetStarted,
    CandidateDashboardConfirmScreen,
    CandidateDashboardIncompletedList,
  },
  computed: {
    ...mapState("Auth", {
      candidate: "candidate",
    }),
    ...mapState("BookingCandidate", {
      bookingCandidates: "bookingCandidates",
    }),
  },
})
export default class CandidateDashboard extends Vue {
  // candidate State
  candidate!: Model

  step = 0

  page = 0

  questionnaire = {}

  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES

  incompletedScreenCount = 0

  isMounted = false

  isReadingMore = false

  bookingCandidates!: any[]

  async beforeMount() {
    if (!this.candidate) {
      return this.$router.push({
        name: "candidate-welcome",
      })
    }

    await this.handleFetch()

    this.isMounted = !!this.bookingCandidates
  }

  async handleFetch() {
    this.isReadingMore = true
    this.page++
    const options = {
      params: {
        expand: [
          "booking",
          "booking.questionnaire",
          "booking.request_business",
        ],
        per_page: 10 * this.page,
        statuses: [
          this.bookingCandidateStatuses.STATUS_AWAIT_CANDIDATE_RESPONSE.key,
          this.bookingCandidateStatuses.STATUS_AWAIT_CONFIRMED_POLICY.key,
          this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
          this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
        ],
        candidate_oid: this.candidate.object_id,
      },
    }

    await this.$store
      .dispatch("BookingCandidate/fetchList", options)
      .then((response) => {
        this.incompletedScreenCount = response.total
      })

    this.isReadingMore = false
  }

  handleComplete(questionnaire) {
    this.questionnaire = questionnaire
    this.step++
  }
}
